import React, { useEffect } from 'react';
import { Link as ScrollLink } from 'react-scroll';
import { ReactTyped } from 'react-typed';
import AOS from 'aos';
import 'aos/dist/aos.css';
import content from '../../../content';
import './HomeDesktop.css';

const { hero } = content;

function HomeDesktop() {
  useEffect(() => {
    AOS.init({ duration: 900, once: true, offset: 80 });
  }, []);

  return (
    <section className="hero" id="heroSection">
      <div className="hero-overlay" />
      <div className="hero-content" data-aos="fade-up">
        {hero.greeting && <p className="hero-greeting">{hero.greeting}</p>}
        <h1 className="hero-name">{content.meta.name}</h1>
        {hero.roles.length > 0 && (
          <div className="hero-typed">
            {hero.roles.length > 1 ? (
              <ReactTyped strings={hero.roles} typeSpeed={55} backSpeed={35} loop />
            ) : (
              hero.roles[0]
            )}
          </div>
        )}
        {hero.tagline && <p className="hero-tagline">{hero.tagline}</p>}
        <div className="hero-cta-group">
          {hero.primaryCta && (
            <ScrollLink
              to={hero.primaryCta.target}
              smooth={true}
              duration={500}
              className="cta-primary"
            >
              {hero.primaryCta.label}
            </ScrollLink>
          )}
          {hero.secondaryCta && (
            <ScrollLink
              to={hero.secondaryCta.target}
              smooth={true}
              duration={500}
              className="cta-secondary"
            >
              {hero.secondaryCta.label}
            </ScrollLink>
          )}
        </div>
      </div>
      <div className="hero-scroll-hint">
        <span className="scroll-dot"></span>
      </div>
    </section>
  );
}

export default HomeDesktop;
